import React from 'react';

import { EmojiFlag, FlagSvgFallback } from './components';

interface FlagProps {
  countryIsoCode: string;
  size?: string;
}

export type FlagComponentProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> & FlagProps;

export function Flag(props: FlagComponentProps): JSX.Element {
  const isWindows = navigator.userAgent.includes("Win");

  return isWindows
    ? <FlagSvgFallback {...props} />
    : <EmojiFlag {...props} />;
}
